import api from '../resources/privilege-templates.api';
import actionTypes from './action-types';

export const deletePrivilegeTemplateRequest = () => ({
  type: actionTypes.DELETE_PRIVILEGE_TEMPLATE_REQUEST,
});

export const deletePrivilegeTemplateSuccess = (id) => ({
  type: actionTypes.DELETE_PRIVILEGE_TEMPLATE_SUCCESS,
  id,
});

export const deletePrivilegeTemplateFailure = () => ({
  type: actionTypes.DELETE_PRIVILEGE_TEMPLATE_FAILURE,
});

export const deletePrivilegeTemplate = (id) => async (dispatch) => {
  try {
    dispatch(deletePrivilegeTemplateRequest());

    await api.deletePrivilegeTemplate(id);
    dispatch(deletePrivilegeTemplateSuccess(id));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('DELETE_PRIVILEGE_TEMPLATE', error);
    dispatch(deletePrivilegeTemplateFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/actions/delete-privilege-templates.actions.js